import { CloseButton, Dialog, Stack, Text } from '@chakra-ui/react';
import React from 'react';

interface DialogTitleSubtitleProps {
  title: string | React.ReactNode;
  subtitle?: string | React.ReactNode;
  showCloseButton?: boolean;
}

export const DialogTitleSubtitle = (props: DialogTitleSubtitleProps) => {
  const { title, subtitle, showCloseButton = true } = props;

  return (
    <>
      <Dialog.Header>
        <Stack gap={0} w='full'>
          <Dialog.Title>{title}</Dialog.Title>
          {subtitle && (
            <Text fontSize='md' fontWeight='normal' color='secondary'>
              {subtitle}
            </Text>
          )}
        </Stack>
        {showCloseButton && (
          <Dialog.CloseTrigger>
            <CloseButton />
          </Dialog.CloseTrigger>
        )}
      </Dialog.Header>
    </>
  );
};
